import React from 'react';
import FormPage from '../../components/FormPage/FormPage';

const Diagnostico: React.FC = () => (
  <FormPage
    seoTitle="Diagnóstico Financeiro Gratuito | 77Gestão"
    seoDescription="Agende um diagnóstico financeiro gratuito da sua empresa com o 77Gestão."
    canonical="/diagnostico"
    eyebrow="Gratuito · vagas limitadas"
    heading="Diagnóstico financeiro gratuito"
    intro="A gente olha o seu cenário e mostra, na prática, como ter o controle do seu resultado. Sem compromisso — você sai com clareza, não com um boleto."
    fields={[
      { name: 'nome', label: 'Nome', required: true, placeholder: 'Seu nome' },
      { name: 'email', label: 'E-mail', type: 'email', required: true, placeholder: 'voce@empresa.com.br' },
      { name: 'whatsapp', label: 'WhatsApp', type: 'tel', required: true, placeholder: '(00) 00000-0000' },
      { name: 'empresa', label: 'Empresa', required: false, placeholder: 'Nome da empresa' },
    ]}
    subject="Pedido de diagnóstico gratuito — 77gestão"
    submitLabel="Quero meu diagnóstico"
    successTitle="Recebemos seu pedido!"
    successText="Nossa equipe vai entrar em contato pelo WhatsApp ou e-mail para agendar seu diagnóstico. Até já!"
  />
);

export default Diagnostico;
